<template>
  <div class="p-4 h-full">
    <div class="flex flex-col xl:flex-row w-full h-full text-[--color-body-text] gap-6 lg:gap-8">
      <div class="relative flex xl:w-[45%] h-full border border-[--color-gray-line] rounded-lg">
        <VcBadge
          class="absolute left-4 top-4 py-1.5 px-4 transition-transform bg-[--color-berry] border-[--color-berry] rounded-md uppercase text-sm"
          variant="solid"
        >
          {{ $t("shared.5-products.main-item.featured") }}
        </VcBadge>
        <VcImage
          :src="product.imgSrc"
          :alt="product.name"
          size-suffix="md"
          class="size-full select-none rounded object-contain object-center aspect-video"
          :lazy="lazy"
        />
      </div>
      <div class="flex flex-col grow h-full">
        <div class="w-full text-3xl font-semibold">
          {{
            // Innovadis custom: Get product name and when it is a variation, prefix with group name
            getProductName(product, true)
          }}
        </div>
        <div v-if="productGroupMaterial" class="w-full truncate">{{ productGroupMaterial }}</div>
        <!--
        Due to lack of content we show some properties for now.
        When more marketing texts are available we want to switch back to decriptions
        <div v-if="product.description?.content" class="w-full mt-3 lg:mt-6">{{ product.description.content }}</div> -->
        <div v-if="filteredProps" class="w-full mt-3 lg:mt-6">
          <div v-for="property in filteredProps" :key="property.id" class="properties__prop">
            <div class="properties__label text-[--color-body-text] whitespace-nowrap">
              {{
                $t(`shared.catalog.product_details.properties.property_${property.label}`) ===
                `shared.catalog.product_details.properties.property_${property.label}`
                  ? property.label
                  : $t(`shared.catalog.product_details.properties.property_${property.label}`)
              }}
            </div>

            <div class="properties__value text-right font-semibold">
              <span v-if="isHTML(property)">
                <VcMarkdownRender :src="String(property.value)" />
              </span>
              <span v-else>
                {{ property.value }}
              </span>
            </div>
          </div>
        </div>
        <div class="flex flex-col w-full grow justify-end">
          <DiscountBadge :price="product.price!" />

          <!-- <VcProductActions direction="vertical" with-background class="absolute -right-4 -top-4 z-[2]">
              <AddToList :product="product" />
              <AddToCompareCatalog v-if="$cfg.product_compare_enabled" :product="product" />
            </VcProductActions> -->

          <!-- Product price -->
          <!-- BB2B-122 Hide price on product tile for now due to performance issues on min variation price
            <div class="w-full" v-if="price">
              <InnoItemPriceCatalog
                :with-from-label="product.hasVariations || product.isConfigurable"
                :value="price"
                class="text-[--color-price]"
              />
              <span class="text-xs flex">{{ priceUnitText }}</span>
            </div>
            <div v-else class="price-on-request">
              {{ $t("ui_kit.labels.price-on-request") }}
            </div> -->
        </div>
        <div class="w-full mt-4">
          <InnoButton shape="pill" :to="link" size="lg" class="flex-1 lg:flex-none w-full">
            {{ $t("shared.5-products.main-item.more-info") }}
          </InnoButton>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { PropertyValueTypes, type Product, type Property } from "@/core/api/graphql/types";
import { getProductRoute } from "@/core/utilities";
import { computed } from "vue";
import DiscountBadge from "../../catalog/components/discount-badge.vue";
//import InnoItemPriceCatalog from "@/ui-kit//components/molecules/innovadis/inno-item-price-catalog.vue";
import InnoButton from "@/ui-kit/components/molecules/innovadis/inno-button.vue";
import { CUSTOM_PROPERTY_GROUP_MATERIAL, CUSTOM_PROPERTIES_FOR_5_FEATURED_PRODUCTS } from "@/shared/common/constants";
import { getCustomPropertyValue, getProductName } from "@/core/utilities/innovadis";

interface IProps {
  product: Product;
  lazy?: boolean;
}

const props = withDefaults(defineProps<IProps>(), {
  lazy: true,
});

const link = computed(() => getProductRoute(props.product.id, props.product.slug));
//const price = computed(() => (props.product.hasVariations ? props.product.minVariationPrice : props.product.price));

// price unit text
//const priceUnitText = computed(() => getProductPriceUnitText(props.product));

// get group material value from product properties
const productGroupMaterial = computed(() =>
  getCustomPropertyValue(props.product.properties, CUSTOM_PROPERTY_GROUP_MATERIAL),
);

// get properties
const filteredProps = props.product.properties
  .filter((prop) => CUSTOM_PROPERTIES_FOR_5_FEATURED_PRODUCTS.includes(prop.name) && prop.value)
  .map((prop) => ({
    ...prop,
    label: prop.label
      ? prop.label.replace(/_/g, " ").replace(/^./, (char) => char.toUpperCase()) // Capitalize only the first character
      : prop.label,
  }));

function isHTML(property: Property): boolean {
  return (property.propertyValueType as PropertyValueTypes) === PropertyValueTypes.Html;
}
</script>
